import * as React from 'react';
import { Loader } from '../Loader';

// PropType definition
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
;

// Unit Details component with props and its types
const _DetailWidget = props => {
  const {
    loader,
    width,
    title,
    subTitle,
    message,
    disabled
  } = props;
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-detail ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [/*#__PURE__*/_jsx("div", {
          className: "kc-ui-title-heading",
          children: /*#__PURE__*/_jsxs("div", {
            className: "kc-ui-title",
            children: [title, /*#__PURE__*/_jsx("span", {
              className: "kc-ui-subtitle",
              children: subTitle
            })]
          })
        }), loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsx("div", {
          className: "kc-ui-title-message",
          children: message && message.length && Array.isArray(message) ? message.map((messages, index) => {
            return /*#__PURE__*/_jsx("div", {
              className: "kc-ui-message",
              children: messages
            }, index);
          }) : /*#__PURE__*/_jsx("div", {
            className: "kc-ui-message",
            children: message
          })
        })]
      })
    })
  });
};

// Prop type definition for compile time

// Default props
_DetailWidget.defaultProps = {
  loader: false,
  width: "100%",
  title: "",
  subTitle: "",
  message: "",
  disabled: false
};
export const DetailWidget = /*#__PURE__*/React.memo(_DetailWidget);